import { useContext } from "react";

import { flashContext } from "@/context/flash-context";

export const useFlashMessage = () => {
  const { applyFlashContext } = useContext(flashContext);

  const showFlashMessage = (
    message: string,
    type:
      | "success2"
      | "success"
      | "primary"
      | "warning"
      | "warning2"
      | "danger" = "success2",
    position?: string,
  ) => {
    applyFlashContext({
      message,
      type,
      position,
    });
  };

  return { showFlashMessage };
};
